import { HttpClient } from "@angular/common/http";
import { Injectable, InjectionToken, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { OAuthStorageAdapter } from "@impacgroup/angular-oauth-base";
import { ApiListQueryParameter, BaseDatatableStateSaveMode } from "@impacgroup/angular-baselib";
import { map } from "rxjs/operators";
import { plainToInstance } from "class-transformer";
import { SalesManagerOrder, SalesmanagerOrderDetails } from "../../api-models/SalesManagerOrder";

export interface ISalesManagerOrderConfigService {
    salesManagerOrdersAPI: string;
    utcDateFormat: string;
    datatableStateSaveMode: BaseDatatableStateSaveMode;
}

export const SalesManagerOrderConfigService = new InjectionToken<ISalesManagerOrderConfigService>("SalesManagerOrderConfig");

@Injectable()
export class SalesManagerOrdersService {
    public UTCDATEFORMAT: string = "";
    public datatableStateSaveMode: BaseDatatableStateSaveMode;

    constructor(
        @Inject(SalesManagerOrderConfigService) private salesManagerOrderConfig: ISalesManagerOrderConfigService,
        private http: HttpClient,
        private oauthStorageAdapter: OAuthStorageAdapter
    ) {
        this.UTCDATEFORMAT = this.salesManagerOrderConfig.utcDateFormat;
        this.datatableStateSaveMode = this.salesManagerOrderConfig.datatableStateSaveMode;
    }

    public list(params: ApiListQueryParameter): Observable<{ list: SalesManagerOrder[]; count: number; total: number }> {
        return this.http
            .get<any>(this.getSalesManagerOrdersServiceUrl(""), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON(),
                params: params as any,
                observe: "response"
            })
            .pipe(
                map((result) => {
                    let count = result.body.length;
                    let total = result.body.length;
                    try {
                        count = parseInt(result.headers.get("X-Pagination-Count"), 10);
                    } catch (e) {}
                    try {
                        total = parseInt(result.headers.get("X-Total-Count"), 10);
                    } catch (e) {}

                    return {
                        list: plainToInstance(SalesManagerOrder, result.body as any[]),
                        count: count,
                        total: total
                    };
                })
            );
    }

    public downloadSalesManagerOrderCSV(id: string): Observable<Blob> {
        return this.http.get(this.getSalesManagerOrdersServiceUrl(`${id}/csv`), {
            headers: this.oauthStorageAdapter.getAuthHeadersWithoutContentType(),
            responseType: "blob"
        });
    }

    public readSalesManagerOrder(id: string): Observable<SalesmanagerOrderDetails> {
        return this.http
            .get(this.getSalesManagerOrdersServiceUrl(`${id}`), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON()
            })
            .pipe(
                map((result) => {
                    return plainToInstance(SalesmanagerOrderDetails, result);
                })
            );
    }

    private getSalesManagerOrdersServiceUrl(postfix: string): string {
        return this.salesManagerOrderConfig.salesManagerOrdersAPI + postfix;
    }
}
